import ChangeLeverage from "@/views/leverage/ChangeLeverage";

export default { ChangeLeverage };
